import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./Game_Statistics.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Game_Statistics_cards from "./Game_Statistics_cards/Game_Statistics_cards";
import No_data from "../Common/No_data/No_data";

function Game_Statistics() {
  const [activeTab, setActiveTab] = useState("today");

  const statsData = {
    today: {
      totalBet: "₹0.00",
      totalLotteryBet: "₹0.00",
      numberOfBets: "0",
      winningAmount: "₹0.00",
    },
    yesterday: {
      totalBet: "₹120.00",
      totalLotteryBet: "₹100.00",
      numberOfBets: "5",
      winningAmount: "₹20.00",
    },
    week: {
      totalBet: "₹450.00",
      totalLotteryBet: "₹400.00",
      numberOfBets: "18",
      winningAmount: "₹50.00",
    },
    month: {
      totalBet: "₹1200.00",
      totalLotteryBet: "₹1000.00",
      numberOfBets: "45",
      winningAmount: "₹200.00",
    },
  };

  const data = statsData[activeTab];

  return (
    <section className="Game_Statistics">
      <div className="container">

        <Common_white_header headingText={"Game Statistics"} />

        {/* TABS */}

        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="stats_tabs"
        >
          <Tab eventKey="today" title="Today"></Tab>
          <Tab eventKey="yesterday" title="Yesterday"></Tab>
          <Tab eventKey="week" title="This Week"></Tab>
          <Tab eventKey="month" title="This Month"></Tab>
        </Tabs>

        {/* TOTAL BET CARD */}

        <div className="stats_card total_bet_card">
          <div className="total_amount">{data.totalBet}</div>
          <div className="total_label">Total bet</div>
        </div>

        {/* LOTTERY CARD */}

        <Game_Statistics_cards data={data} />
        <Game_Statistics_cards data={data} />
        <Game_Statistics_cards data={data} />
        <Game_Statistics_cards data={data} />
        <Game_Statistics_cards data={data} />
        <Game_Statistics_cards data={data} />

         <No_data/>

      </div>
    </section>
  );
}

export default Game_Statistics;